/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function LoadCart() {
  $('.cart-open').click(function(e) {
    if(template != "cart") {
      e.preventDefault();
      OpenCart();
    }
  });
  /*
  $('body').on('click', '.cart_upsell-toggle a', function(e) {
    e.preventDefault();
    let $target = $(e.currentTarget);

    $target.toggleClass('active');
    $target.closest('.cart_upsell-toggle').next('.cart_upsell-content').slideToggle(300);
  });
  */
  $('body').on('click', '[name="notes"]', function(e) {
    let $note_fields = $('[name="notes"]:checked');
    let values = '';
    for(let i = 0; i < $note_fields.length; i++) {
      if(values == '') {
        values = $note_fields[i].value;
      } else {
        values += ' + ' + $note_fields[i].value;
      }
    }
    $('[name="note"]').val(values);
  });
}
function OpenCart() {
  $('html').addClass('menu-active').addClass('cart-active');
  hj('trigger', 'ajax_cart_use');
}
function CloseCart() {
  $('html').removeClass('menu-active').removeClass('cart-active');
}
function onQuantityChange(field) {
  CartJS.updateItem($(field).data('index'), field.value);
}
//#endregion Cart

//#region Product Form
const productData = $("#ProductJson").html();
const originalSelectorId = '#Variant';
const $productForm = $('#AddToCartForm');
function getCurrentVariant() {
  return product_form.$data.current_variant;
};
function ProductFormOptions() {
  var currentVariant = getCurrentVariant();

  // set compare price
  localStorage.setItem(currentVariant.id, currentVariant.compare_at_price);

  updateSlider(currentVariant);

  $('[name="warranty"]').on("change", function() {
    updatePrice(getCurrentVariant());
  });
}
function UpdateSelectedVariant(variant) {
  updateHistoryState(variant);
  updateMasterSelect(variant);
  updatePrice(variant);
  updateStock(variant);
  updateCondition(variant);
  updateSlider(variant);

  // set compare price
  localStorage.setItem(variant.id, variant.compare_at_price);
}

/**
 * Updates the product price
 *
 * @param {Variant} variant - The new variant
 * @param {jQuery} $price - The product price container
 */
function updatePrice(variant) {
  if(variant.available) {
    $('#AddToCart').removeAttr('disabled');
    $('[data-atc-text]').text($('[data-atc-text]').data('atc-text'));
    $('[data-atc-text-sm]').text($('[data-atc-text-sm]').data('atc-text-sm'));
  } else {
    $('#AddToCart').attr('disabled', true);
    $('[data-atc-text]').text('Sold out');
    $('[data-atc-text-sm]').text('Sold out');
  }

  let additional_price = 0;

  if($('[name="warranty"]').length > 0) {
    let $warranty_option = $('[name="warranty"]:checked');
    additional_price += parseInt($warranty_option.data('warranty-price'));
  }

  var $price = $(selectors.price);
  var onSale = variant.price < variant.compare_at_price;
  // Update sale status
  if(onSale) {
    $($price).addClass('on_sale');
  } else {
    $($price).removeClass('on_sale');
  }
  
  // Update prices
  $(selectors.regular_price).html(formatMoney(variant.price + additional_price, "${{amount}}"));
  if(onSale) {
    $(selectors.sale_price).html(formatMoney(variant.compare_at_price + additional_price, "${{amount}}"));
  }
  $(selectors.zip_price).html(formatMoney(variant.price / 4, "${{amount}}"));
  $(selectors.afterpay_price).html(formatMoney(variant.price / 4, "${{amount}}"));
  $('[data-add-to-cart]').data('cart-price', variant.price + additional_price);
}

// Adds AJAX Add to cart to the Product Form
function ProductFormATC() {
  $('#AddToCartForm').submit(function(e) {
    e.preventDefault();

    let selected_variant = $('#Variant').val();

    CartJS.addItem(selected_variant);

    if($('[name="warranty"]').length > 0) {
      let $selected_warranty = $('[name="warranty"]:checked');
      if($selected_warranty.val() != "") {
        CartJS.addItem($selected_warranty.val());
      }
    }
  });
}
$('.main_content_warrenty label.warranty-option').click(function(){
    event.preventDefault();
    if($(this).find('input').is(':checked')){
        $(this).find('input').prop('checked', false)
        var pr = $('.product-checkout .form-row .col-auto .text-dark.tst strong').text().replace('$', '').replace(',', '')
        console.log(parseFloat(pr) - 59)
        // $('.product-checkout h3.text-dark.tst strong').html('$'+((parseFloat(pr) - 59).toFixed(2)).toLocaleString())
        // $('.col-auto h4.tstt').html('$'+((parseFloat(pr) - 59).toFixed(2)).toLocaleString())
        ProductFormOptions()
    }else{
         $(this).find('input').prop('checked', true)
        var pr = $('.product-checkout .form-row .col-auto .text-dark.tst strong').text().replace('$', '').replace(',', '')
        console.log(parseFloat(pr) + 59)
        console.log('js file')
        // $('.product-checkout h3.text-dark.tst strong').html('$'+((parseFloat(pr) + 59).toFixed(2)).toLocaleString())
        // $('.col-auto h4.tstt').html('$'+((parseFloat(pr) + 59).toFixed(2)).toLocaleString())
        ProductFormOptions()
    }
})


document.addEventListener("DOMContentLoaded", function() {
 document.addEventListener('change', function(e){
  	var el = e.target;
    
    if(el.classList.contains('related_product_block_check_input') || el.closest('.related_product_block_check_input')) {
      let isChecked = el.checked;
      let parentEl = el.closest('.related_product_block_check');
      if(isChecked) {
        parentEl.classList.add('checked');
      } else {
          parentEl.classList.remove('checked');
      }
      
    }
  });

  var swatchWithImage = document.querySelector(".block-swatch__item-popout-image");
  var triangle = document.querySelector(".condition-premium-popup-triangle");
  if(swatchWithImage && triangle){
    var parentSwatch = swatchWithImage.closest(".block-swatch");

    if(parentSwatch){
     var position = parentSwatch.offsetLeft + (parentSwatch.getBoundingClientRect().width / 2 - 19);
     triangle.style.left =  position + "px";
     triangle.style.opacity = 1; 
    }
  }
  window.addEventListener('resize', function(e){
   var swatchWithImage = document.querySelector(".block-swatch__item-popout-image");
  var triangle = document.querySelector(".condition-premium-popup-triangle");
  if(swatchWithImage && triangle){
    var parentSwatch = swatchWithImage.closest(".block-swatch");

    if(parentSwatch){
     var position = parentSwatch.offsetLeft + (parentSwatch.getBoundingClientRect().width / 2 - 19);
     triangle.style.left =  position + "px";
    }
  }
  });
  
});


